import { getLogicNodeSchema } from '../../Hasp/properties/v2/logic/index.js';
import { describeLogicNode } from '../../logic/logicPresentation.js';
import { LOGIC_NODE_SIZE } from '../../logic/logicMigration.js';
import { buildGraphScene, GRAPH_ATTR } from '../graph/graphScene.js';

export const LOGIC_COLORS = Object.freeze({
    body: '#1e293b',
    text: '#f8fafc',
    summary: '#cbd5e1',
    port: '#0f172a',
    portStroke: '#e2e8f0',
    objectPort: '#f59e0b',
    objectWire: '#f59e0b',
    // A GPIO entity's state and the value a GPIO binding drives.
    valueWire: '#22c55e',
    actionWire: '#94a3b8',
    selected: '#facc15',
    valid: '#22c55e',
    error: '#ef4444',
    warning: '#f59e0b',
});

export const LOGIC_ATTR = GRAPH_ATTR;

/** How the event/action graph is drawn (see buildGraphScene). */
export const logicRenderDomain = Object.freeze({
    namePrefix: 'logic',
    getNodeSchema: getLogicNodeSchema,
    nodeSize: LOGIC_NODE_SIZE,
    describeNode: describeLogicNode,
    colors: LOGIC_COLORS,
    wireColor: wire => {
        if (wire.from.object !== undefined) return LOGIC_COLORS.objectWire;
        return wire.from.port === 'state' || wire.from.port === 'value' ? LOGIC_COLORS.valueWire : LOGIC_COLORS.actionWire;
    },
});

// A UI object that emits events has one port: `events`, on its right edge.
export const LOGIC_OBJECT_PORT = Object.freeze({ id: 'events', dir: 'out', side: 'right' });

/** Scene objects for Logic: `hasEvents` decides the object's `events` port. */
export function logicSceneObjects(objects) {
    return objects.map(object => ({ ...object, ports: object.ports ?? (object.hasEvents ? [LOGIC_OBJECT_PORT] : []) }));
}

/**
 * Build the logic overlay of one page as a Konva group (see buildGraphScene;
 * `objects` are [{ uuid, rect, hasEvents }]).
 */
export function buildLogicScene({ objects, ...scene }) {
    return buildGraphScene({ ...scene, domain: logicRenderDomain, objects: logicSceneObjects(objects) });
}
